import React from 'react'

import { properties } from 'app-config'
import { NEUTRAL_COLOURS } from 'constants/colors'

import { Icon, Typography } from 'components'

import i18n from 'translations'

import { StyledContainer, StyledLogo } from '../ButtonsStyled'

const ReferralButton = () => (
  <StyledContainer href={properties.referralLink} target="_blank">
    <StyledLogo src="/images/amazon-logo.svg" />
    <div>
      <Typography variant="div" bold>
        {i18n.t('module:Shell:ReferralButton:label')}
        {' '}
        <Typography margin="0 0 5px" variant="span">
          <Icon color={NEUTRAL_COLOURS.WHITE} height={11} icon="external-link" />
        </Typography>
      </Typography>
      <Typography fontSize={14}>
        {i18n.t('module:Shell:ReferralButton:description')}
      </Typography>
    </div>
  </StyledContainer>
)

export default ReferralButton
